import React from 'react';
import Progress from 'bit/mobiauto.web-ui-components.components.progress/Progress';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import TableItemRow from './components/TableItemRow';
import TableHead from './components/TableHead';
import formatCpfCnpj from 'helpers/formatCpfCnpj';
import { formatPhoneNumber } from 'helpers/formatPhoneNumber';
import * as S from './styles';

function EnhancedTable({
  clients = [],
  isLoading = false,
  handleClickListItem,
  handleClickEditListItem,
  pagination = { page: 0, rowsPerPage: 5 },
  setPagination = null,
  totalElements = 0,
  classes,
}) {
  //CHANGE_PAGE
  const handleChangePage = (_, page) => {
    setPagination &&
      setPagination(olsState => ({
        ...olsState,
        page,
      }));
  };

  //CHANGE_ROWS_PER_PAGE
  const handleChangeRowsPerPage = event => {
    setPagination &&
      setPagination(oldState => ({
        ...oldState,
        rowsPerPage: event.target.value,
        page: 0,
      }));
  };

  if (isLoading) {
    return (
      <S.ProgressWrapper>
        <Progress medium />
      </S.ProgressWrapper>
    );
  }

  const contactList =
    clients.map(item => {
      return {
        ...item,
        cpfCnpj: item.cpfCnpj ? formatCpfCnpj(item.cpfCnpj) : '-',
        phone: item.phone ? formatPhoneNumber(item.phone) : '-',
      };
    }) || [];

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} aria-labelledby="tableTitle">
          <TableHead />
          <TableBody>
            {contactList.map(item => {
              return (
                <TableItemRow
                  key={item.id}
                  order={item}
                  handleClickListItem={() => handleClickListItem(item)}
                  handleClickEditItem={() => handleClickEditListItem(item)}
                />
              );
            })}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        rowsPerPageOptions={[5, 10]}
        component="div"
        count={totalElements}
        rowsPerPage={pagination.rowsPerPage}
        page={pagination.page}
        backIconButtonProps={{
          'aria-label': 'Previous Page',
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page',
        }}
        labelRowsPerPage="Linhas por página"
        labelDisplayedRows={({ from, to, count }) => {
          const labelDisplayedRows = `${from}-${
            to === -1 ? count : to
          } de ${count}`;

          return labelDisplayedRows;
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default withStyles(S.styles)(EnhancedTable);
